export const meta = {
  title: 'Acceptable Use Policy | gridcraft',
  description:
    'Rules for responsible use of gridcraft guides, download resources, website tools and support channels.',
  updated_at: '2026-10-18',
};

## Purpose

This policy applies to gridcraft (gridcraft.me), including download resources, installation guides, Excel comparisons, usage reviews, website tools and support channels. It forms part of our [Terms of Service](/terms-of-service).

## Permitted use

You may browse guides, follow download links, compare software, try available tools and contact support for lawful purposes. Use software under its applicable license and only work with data you are authorized to access.

## Prohibited activities

Do not use the website or support channels to:

- Distribute malware, malicious spreadsheets, phishing links or deceptive installers.
- Share pirated software, stolen license keys or instructions intended to bypass software licensing.
- Attempt unauthorized access to accounts, servers, private files or other users' information.
- Disrupt service through excessive automated requests, denial-of-service attacks or attempts to evade access controls.
- Submit spam, threats, harassment, unlawful content or private information about others without authorization.
- Infringe copyright, trademarks, privacy or other rights, including unauthorized bulk republication of our articles.
- Impersonate gridcraft, ArtCraft, Microsoft or another party, or falsely claim official endorsement.

## Files and support requests

Only submit files and screenshots that you have permission to share. Remove confidential business data, personal information, passwords and license keys first. Do not send suspicious executables or active malicious workbooks as attachments; describe the issue and provide the relevant page URL instead.

## Automated access and security research

Keep automated access proportionate and respect published access restrictions. Do not bypass authentication or technical protections. If you discover a possible vulnerability, report it privately without accessing other people's data or disrupting the website.

## Reporting issues

Send reports to [support@gridcraft.me](mailto:support@gridcraft.me). Include the page URL, a description and any safe supporting details. You can report a broken or suspicious download link, inaccurate comparison, copyright concern, abusive content or suspected security issue. Do not include exploit payloads or sensitive data in an initial report.

## Enforcement and review

We may investigate reports, correct or remove content, limit requests, or restrict access or accounts where necessary to address misuse. We may cooperate with authorities when required by applicable law. If you believe an action was mistaken, email support with enough detail for us to review it.

## Updates and contact

We may revise this policy as website features change. The latest revision date appears above. Questions: [support@gridcraft.me](mailto:support@gridcraft.me).
